"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Spacing = void 0;
/*
 * Copyright (c) 2023 Discover Financial Services
 * Licensed under MIT License. See License.txt in the project root for license information
 */
const molecule_1 = require("./molecule");
const props_1 = require("../common/props");
/**
 * The spacing molecule.
 * @category Molecules
 */
class Spacing extends molecule_1.Molecule {
    constructor(molecules) {
        super("Spacing", molecules);
        this.sectionPadding = new props_1.PropertyNumberSelectable("Section Padding", false, this, [1, 2, 3, 4, 5, 6, 7, 8, 9, 10], 3);
        this.paragraphPadding = new props_1.PropertyNumberSelectable("Paragraph Padding", false, this, [1, 2, 3, 4, 5], 2);
    }
    deserialize(obj) {
        if (!obj)
            return;
        super.deserialize(obj);
        this.sectionPadding.deserialize(obj.sectionPadding);
        this.paragraphPadding.deserialize(obj.paragraphPadding);
    }
    serialize() {
        const obj = {};
        obj.sectionPadding = this.sectionPadding.serialize();
        obj.paragraphPadding = this.paragraphPadding.serialize();
        return obj;
    }
}
exports.Spacing = Spacing;
